import React, { useState, useMemo, useEffect } from 'react'
import _ from 'lodash'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import ListView from '../components/ui/layout/newListView'
import InactiveListView from '../components/ui/layout/InactiveListView'
import { useSelector, useDispatch } from 'react-redux'
import {
  setCaptureSelection, setCaptureSelections, setCaptureModal,
  setView,
  setCapturesRendered
} from '../redux/actions/select'
import { getViolations } from '../redux/actions/violations'
// import { ElevioIntegration } from '../components/ui/tools'
import {
  formatBorderClass, getSourceDescription, getSeverityClass, onQuickFilter
} from '../utils'
import Slide from '@material-ui/core/Slide'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import ImageSearchIcon from '@material-ui/icons/ImageSearch'
import AnnouncementIcon from '@material-ui/icons/Announcement'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import log from 'loglevel'

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    position: 'fixed'
  },
  paperRoot: {
    backgroundColor: '#3134384a'
  },
  whiteText: {
    color: '#FFFFFF'
  },
  setFilterRoot: {
    backgroundColor: '#3984F7'
  }
}))
const CaptureListview = (props) => {
  const parsedProps = queryString.parse(props.location.search)
  const classes = useStyles()
  const MatchPage = parseInt(parsedProps.page, 10)
  const ActiveCapture = parseInt(parsedProps.activeCapture, 10)
  // const ActiveView = parsedProps.view
  const [viewData, setViewData] = useState([])
  const [capturesExhausted, setCapturesExhausted] = useState(false)
  const [renderCaptures, setRenderCaptures] = useState(false)
  const Captures = useSelector(state => state.violations.violations.captures)
  const Filter = useSelector(state => state.selection.Filter)
  // const PageLimit = useSelector(state => state.selection.PageCaptureLimit)
  const CaptureModal = useSelector(state => state.selection.CaptureModal)
  const SettingsModal = useSelector(state => state.selection.SettingsModal)
  const FilterModal = useSelector(state => state.selection.FilterModal)
  const PrinterModal = useSelector(state => state.selection.PrinterModal)
  const ShareModal = useSelector(state => state.selection.ShareModal)
  const SearchModal = useSelector(state => state.selection.SearchModal)
  const isModalOpened = CaptureModal || SettingsModal || FilterModal || PrinterModal || ShareModal || SearchModal
  const dispatch = useDispatch()
  const handleCaptureSelection = (e, capture) => {
    if (e) { e.stopPropagation() }
    dispatch(setCaptureSelection(capture))
    dispatch(setCaptureSelections([capture.violationID]))
    dispatch(setCaptureModal(!CaptureModal))
  }
  const handleQuickFilter = (map) => {
    onQuickFilter(map, dispatch, Filter)
    props.history.push({
      pathname: '/captures',
      search: '?view=list&page=1&activeCapture=0'
    })
  }
  useMemo(() => {
    dispatch(setView('list-view'))
    log.info('repopulating views')
    if (Captures.length > 0) {
      setCapturesExhausted(true)
    } else {
      setCapturesExhausted(false)
    }
    if (Captures.length === 0) {
      setViewData([])
    } else {
      dispatch(setCapturesRendered(Captures.length - 1))
      dispatch(setCaptureSelections([Captures[0].violationID]))
      setViewData(Captures)
      setRenderCaptures(true)
    }
  }, [Captures, dispatch])

  useEffect(() => {
    const handleWheel = _.throttle((event) => {
      if (isModalOpened || !event) { return false }
      if (event.type.toUpperCase() === 'WHEEL' && Math.sign(event.deltaY) === -1) {
        if (ActiveCapture - 1 >= 0) {
          props.history.push({
            pathname: '/captures',
            search: `?view=list&page=${MatchPage}&activeCapture=${ActiveCapture - 1}`
          })
          setRenderCaptures(true)
          dispatch(setCaptureSelections(viewData[ActiveCapture - 1].violationID))
        }
      } else if (event.type.toUpperCase() === 'WHEEL' && Math.sign(event.deltaY) === 1) {
        if (ActiveCapture < viewData.length - 1) {
          props.history.push({
            pathname: '/captures',
            search: `?view=list&page=${MatchPage}&activeCapture=${ActiveCapture + 1}`
          })
          setRenderCaptures(true)
          dispatch(setCaptureSelections(viewData[ActiveCapture + 1].violationID))
        }
      }
    }, 250)
    const handleKey = _.debounce((event) => {
      if (isModalOpened || !event) { return false }
      if (event.type.toUpperCase() === 'KEYDOWN' && event.key.toUpperCase() === 'ARROWUP') {
        if (ActiveCapture - 1 >= 0) {
          props.history.push({
            pathname: '/captures',
            search: `?view=list&page=${MatchPage}&activeCapture=${ActiveCapture - 1}`
          })
          setRenderCaptures(true)
          dispatch(setCaptureSelections(viewData[ActiveCapture - 1].violationID))
        }
      } else if (event.type.toUpperCase() === 'KEYDOWN' && event.key.toUpperCase() === 'ARROWDOWN') {
        if (ActiveCapture < viewData.length - 1) {
          props.history.push({
            pathname: '/captures',
            search: `?view=list&page=${MatchPage}&activeCapture=${ActiveCapture + 1}`
          })
          setRenderCaptures(true)
          dispatch(setCaptureSelections(viewData[ActiveCapture + 1].violationID))
        }
      }
      // dispatch(setCaptureSelections(viewData[ActiveCapture].violationID))
    }, 50)
    // dispatch(setCaptureSelections(viewData[ActiveCapture].violationID))
    document.addEventListener('wheel', handleWheel, false)
    document.addEventListener('keydown', handleKey, false)
    return () => {
      document.removeEventListener('wheel', handleWheel, false)
      document.removeEventListener('keydown', handleKey, false)
    }
  }, [ActiveCapture, MatchPage, props.history, viewData.length, isModalOpened, dispatch, viewData])

  return (
    <>
      {/* <div className='arrow-right' /> */}
      <Grid container alignItems='center' direction='column' spacing={3} className={`my-auto ${classes.pageContainer}`}>
        {
          viewData.length === 0
            ? (
              <Grid
                container
                direction='row'
                justify='center'
                className='w-100 mx-auto'
                style={{
                  height: '15em',
                  maxWidth: '40em',
                  marginTop: '4em'
                }}
                key='no-return-message-grid'
              >
                <Paper
                  className='w-100 mx-auto'
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                  classes={{ root: classes.paperRoot }}
                  elevation={3}
                >
                  <Grid container item direction='column' justify='center' alignContent='center'>
                    <Grid container item justify='center' alignContent='center'>
                      {capturesExhausted === true
                        ? <AnnouncementIcon style={{ fontSize: 'xxx-large' }} color='primary' classes={{ colorPrimary: classes.whiteText }} />
                        : <ImageSearchIcon style={{ fontSize: 'xxx-large' }} color='primary' classes={{ colorPrimary: classes.whiteText }} />}
                    </Grid>
                    <Grid container item justify='center' alignContent='center'>
                      {capturesExhausted &&
                        <Typography
                          variant='h5'
                          color='primary'
                          classes={{ colorPrimary: classes.whiteText }}
                          style={{ fontWeight: 'bold' }}
                          className='mt-2'
                        >
                          Heads up!
                        </Typography>}
                      <Typography
                        variant='h6'
                        color='primary'
                        classes={{ colorPrimary: classes.whiteText }}
                        className='mt-2'
                      >
                        No captures found. Try clearing any saved filters or hitting "refresh".
                      </Typography>
                      {capturesExhausted &&
                        <Typography
                          variant='h6'
                          color='primary'
                          classes={{ colorPrimary: classes.whiteText }}
                          className='mt-1'
                        >
                          Please use a filter to refine your results.
                        </Typography>}
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            ) : (
              <>
                <Slide in={renderCaptures} timeout={{ enter: 1, exit: 1 }} direction='up'>
                  <Grid item container direction='row' xs={8} id='prev-capture'>
                    <InactiveListView
                      capture={ActiveCapture === 0 ? viewData[ActiveCapture] : viewData[ActiveCapture - 1]}
                      activeCapture={ActiveCapture}
                      shouldRender={ActiveCapture !== 0}
                      getSourceDescription={getSourceDescription}
                      getSeverityClass={getSeverityClass}
                      setSelectedCapture={handleCaptureSelection}
                      getViolations={getViolations}
                      handleQuickFilter={handleQuickFilter}
                      formatBorderClass={formatBorderClass}
                    />
                  </Grid>
                </Slide>
                <Slide in={renderCaptures} timeout={{ enter: 1, exit: 1 }} direction='up'>
                  <Grid item container direction='row' xs={8} id='active-capture'>
                    <ListView
                      capture={viewData[ActiveCapture]}
                      activeCapture={ActiveCapture}
                      getSourceDescription={getSourceDescription}
                      getSeverityClass={getSeverityClass}
                      setSelectedCapture={handleCaptureSelection}
                      getViolations={getViolations}
                      handleQuickFilter={handleQuickFilter}
                      formatBorderClass={formatBorderClass}
                    />
                  </Grid>
                </Slide>
                {viewData.slice(ActiveCapture + 1, viewData.length).map((card, idx) => {
                  return (
                    <Slide in={renderCaptures} timeout={{ enter: 0, exit: 0 }} key={`next-capture ${card.violationID}`} direction='up'>
                      <Grid item container direction='row' xs={8} id='next-capture'>
                        <InactiveListView
                          capture={card}
                          shouldRender
                          activeCapture={ActiveCapture}
                          getSourceDescription={getSourceDescription}
                          getSeverityClass={getSeverityClass}
                          setSelectedCapture={handleCaptureSelection}
                          getViolations={getViolations}
                          handleQuickFilter={handleQuickFilter}
                          formatBorderClass={formatBorderClass}
                        />
                      </Grid>
                    </Slide>
                  )
                })}
              </>
            )
        }
        {/* <ElevioIntegration keywords={['Capture']} /> */}
      </Grid>
    </>
  )
}
export default withRouter(CaptureListview)
